// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Appointments calendar (react-big-calendar), scoped under .appointments-calendar */

.appointments-calendar .appointments-calendar__frame {
  padding: var(--ds-space-2);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
}

.appointments-calendar .rbc-month-header {
  min-height: 30px;
}

.appointments-calendar .rbc-time-header-cell {
  min-height: 50px;
}

.appointments-calendar .rbc-header span {
  vertical-align: sub;
}

.appointments-calendar .rbc-toolbar {
  gap: var(--ds-space-2);
}

.appointments-calendar .rbc-event,
.appointments-calendar .rbc-agenda-event-cell {
  overflow-wrap: anywhere;
}

/* Agenda titles are buttons (the agenda has no clickable events of its own) */
.appointments-calendar .appointments-calendar__agenda-link {
  height: auto;
  min-height: 40px;
  padding-inline: 0;
  white-space: normal;
  text-align: start;
}

@media (max-width: 767.98px) {
  .appointments-calendar .appointments-calendar__frame {
    padding: var(--ds-space-1);
  }

  /* Compact toolbar: period label on top, then navigation and view switch, each full width */
  .appointments-calendar .rbc-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .appointments-calendar .rbc-toolbar .rbc-toolbar-label {
    order: -1;
    padding: 0;
    font-weight: 600;
    text-align: center;
  }

  .appointments-calendar .rbc-toolbar .rbc-btn-group {
    display: flex;
  }

  .appointments-calendar .rbc-toolbar .rbc-btn-group > button {
    flex: 1 1 0;
    padding-inline: var(--ds-space-1);
  }

  /* Week and month grids keep their columns and scroll sideways inside the frame */
  .appointments-calendar .rbc-time-view,
  .appointments-calendar .rbc-month-view {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .appointments-calendar .is-week .rbc-time-header,
  .appointments-calendar .is-week .rbc-time-content {
    min-width: 640px;
  }

  .appointments-calendar .rbc-month-view .rbc-month-header,
  .appointments-calendar .rbc-month-view .rbc-month-row {
    min-width: 560px;
  }

  .appointments-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
    padding: var(--ds-space-2);
    vertical-align: top;
  }
}

/* An employee of this appointment is on approved leave that day. */
.appointments-calendar .rbc-event.is-leave-conflict {
  outline: 2px dashed var(--ds-danger);
  outline-offset: -2px;
}
.appointments-calendar .rbc-event.is-leave-conflict .rbc-event-content::before {
  content: "⚠ ";
}
`, "",{"version":3,"sources":["webpack://./src/commons/Appointments/AppointmentsCalendar.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA,2FAA2F;EAC3F;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iCAAiC;EACnC;;EAEA,iFAAiF;EACjF;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;AACF;;AAEA,mEAAmE;AACnE;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,aAAa;AACf","sourcesContent":["/* Appointments calendar (react-big-calendar), scoped under .appointments-calendar */\n\n.appointments-calendar .appointments-calendar__frame {\n  padding: var(--ds-space-2);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n}\n\n.appointments-calendar .rbc-month-header {\n  min-height: 30px;\n}\n\n.appointments-calendar .rbc-time-header-cell {\n  min-height: 50px;\n}\n\n.appointments-calendar .rbc-header span {\n  vertical-align: sub;\n}\n\n.appointments-calendar .rbc-toolbar {\n  gap: var(--ds-space-2);\n}\n\n.appointments-calendar .rbc-event,\n.appointments-calendar .rbc-agenda-event-cell {\n  overflow-wrap: anywhere;\n}\n\n/* Agenda titles are buttons (the agenda has no clickable events of its own) */\n.appointments-calendar .appointments-calendar__agenda-link {\n  height: auto;\n  min-height: 40px;\n  padding-inline: 0;\n  white-space: normal;\n  text-align: start;\n}\n\n@media (max-width: 767.98px) {\n  .appointments-calendar .appointments-calendar__frame {\n    padding: var(--ds-space-1);\n  }\n\n  /* Compact toolbar: period label on top, then navigation and view switch, each full width */\n  .appointments-calendar .rbc-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .appointments-calendar .rbc-toolbar .rbc-toolbar-label {\n    order: -1;\n    padding: 0;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  .appointments-calendar .rbc-toolbar .rbc-btn-group {\n    display: flex;\n  }\n\n  .appointments-calendar .rbc-toolbar .rbc-btn-group > button {\n    flex: 1 1 0;\n    padding-inline: var(--ds-space-1);\n  }\n\n  /* Week and month grids keep their columns and scroll sideways inside the frame */\n  .appointments-calendar .rbc-time-view,\n  .appointments-calendar .rbc-month-view {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .appointments-calendar .is-week .rbc-time-header,\n  .appointments-calendar .is-week .rbc-time-content {\n    min-width: 640px;\n  }\n\n  .appointments-calendar .rbc-month-view .rbc-month-header,\n  .appointments-calendar .rbc-month-view .rbc-month-row {\n    min-width: 560px;\n  }\n\n  .appointments-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n    padding: var(--ds-space-2);\n    vertical-align: top;\n  }\n}\n\n/* An employee of this appointment is on approved leave that day. */\n.appointments-calendar .rbc-event.is-leave-conflict {\n  outline: 2px dashed var(--ds-danger);\n  outline-offset: -2px;\n}\n.appointments-calendar .rbc-event.is-leave-conflict .rbc-event-content::before {\n  content: \"⚠ \";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
